import data from "../../../../../src/StateLabel/StateLabel.docs.json";
import * as React from 'react';
export default {
  data,
  React
};